module.exports = __webpack_public_path__ + "assets/img/lp-cert-1.39ee014c.svg";